import React from "react";
import { QuickTableCalculation } from "./QuickTableCalculation";
import { formatNumber } from "./FormatNumbers";
import {
  getL2SheetProperty,
  updateLevel2Properties,
} from "../../../features/reduxworkbook/WorkbookSlice";
import { useDispatch, useSelector } from "react-redux";
import CellFormatter from "./CellFormatter";
import TableHeader from "./TableHeader";
export default function DynamicTable({
  tableHeader,
  tableData,
  headerKeys,
  quickTable,
  SufixPrefix,
  Sheetid,
  rowKeys,
  valueKeys,
  isMeasureOnTop,
  rowTotalColumnKeys,
  isColumnPresent,
  groupByKeys,
  conditionalFormatting,
  maxMinData,
  hierarchy,
  isRowTotalVisible,
  isColumnTotalVisible,
  isCustomAlign,
  rowAlign,
  valueAlign,
  columnTotal,
  grandTotalAccordingToKey,
  vizType,
  setCurrentPage,
  currentPage,
  rowPerPage,
}) {
  console.log(rowKeys.length - 1);
  // console.log(quickTable);
  // console.log(Sheetid);
  const dispatch = useDispatch();
  const result = QuickTableCalculation({
    data: tableData,
    keys: headerKeys,
    quickTable: quickTable,
    isMeasureOnTop: isMeasureOnTop,
    rowTotalColumnKeys: rowTotalColumnKeys,
    isColumnTotalVisible,
    columnTotal,
    valueKeys,
    dispatch,
    updateLevel2Properties,
    Sheetid,
  });
  const getProcessedKey = (key, isMeasureOnTop, groupByKeys) => {
    // console.log(key);

    if (!key.includes("|") && !rowTotalColumnKeys.includes(key)) {
      return key; // Return the key as-is if it doesn't contain "|" or "Total" or " "
    }

    if (key.includes("|")) {
      // Split by "|" and return part based on isMeasureOnTop
      const parts = key.split("|");
      console.log(parts);

      return isMeasureOnTop
        ? parts[0].trim()
        : parts[groupByKeys.length]?.trim();
    }

    if (rowTotalColumnKeys.includes(key)) {
      // Split by "Total" and return part based on isMeasureOnTop
      return key.slice(6);
      // return isMeasureOnTop ? parts[0].trim() : parts[1]?.trim();
    }

    // If none of the above conditions matched, return null or handle as needed
    return null;
  };

  const getNumberObject = (measureKey, SufixPrefix) => {
    const foundItem = SufixPrefix.find((item) => item.key === measureKey);
    const SufixPrefixObject = {
      key: foundItem ? foundItem.key : null,
      numberObject: foundItem ? foundItem.numberObject : null,
    };

    return foundItem ? SufixPrefixObject : null;
  };

  const renderFormattedNumber = (cellValue, numberObject, quickTable) => {
    if (Array.isArray(quickTable) && quickTable.length > 0) {
      // Find if any item in the quickTable matches the conditions
      const foundQuickOption = quickTable.find((item) =>
        [
          "percentageOfRowTotal",
          "percentageOfColumnTotal",
          "percentageOfGrandTotal",
          "runningTotalAcross",
          "runningTotalDown",
          "tableDifferenceAcross",
          "tableDifferenceDown",
          "tableDifferenceDownPercentage",
          "tableDifferenceAcrossPercentage",
          "noCalulation",
          "clearTableCalculation",
        ].includes(item.quickOption)
      );
      console.log(foundQuickOption);

      // If a matching quickOption is found, format the number
      if (foundQuickOption) {
        return formatNumber(cellValue, numberObject);
      } else {
        // Return the original cell value if no matching option is found
        return cellValue;
      }
    } else {
      // Default case when quickTable is empty or undefined
      return formatNumber(cellValue, numberObject);
    }
  };

  const sortArray = useSelector((state) => {
    return getL2SheetProperty(state, Sheetid, "actions", "sort");
  });

  // Render dynamic table rows
  const renderTableRows = () => {
    return (
      <tbody>
        {result.map((row, rowIndex) => {
          // Check if the current cell value is the same as the previous one and is a string
          const isSameAsPrevious = (key, index) =>
            rowIndex > 0 &&
            typeof row[key] === "string" &&
            result[rowIndex - 1][key] === row[key];

          return (
            <tr key={row.rowKey}>
              {headerKeys.map((headerItem, index) => {



                const cellValue = row[headerItem];
                const displayValue =
                  typeof cellValue === "number" && isNaN(cellValue)
                    ? "-"
                    : cellValue;

                const measureKey = getProcessedKey(
                  headerItem,
                  isMeasureOnTop,
                  groupByKeys
                );
                const { key, numberObject } =
                  getNumberObject(measureKey, SufixPrefix) || {};
                console.log(measureKey);
                console.log(headerItem);

                const formattedObject =
                  conditionalFormatting !== undefined &&
                  CellFormatter(
                    measureKey,
                    displayValue,
                    conditionalFormatting,
                    maxMinData,
                    isCustomAlign,
                    rowAlign,
                    valueAlign,
                    quickTable,
                    grandTotalAccordingToKey,
                    columnTotal
                  );
                console.log(formattedObject);

                const {
                  formattedValue,
                  fontColor,
                  bgColor,
                  rowAlignment,
                  valueAlignment,
                } = formattedObject || {};

                // Calculate rowSpan for the current cell
                if (!isSameAsPrevious(headerItem, index)) {
                  let rowSpan = 1;
                  for (
                    let i = rowIndex + 1;
                    i < result.length &&
                    typeof result[i][headerItem] === "string" &&
                    result[i][headerItem] === cellValue;
                    i++
                  ) {
                    rowSpan++;
                  }

                  const startScrolling = rowKeys.length;
                  console.log(bgColor);
                  console.log(typeof displayValue);

                  return (
                    <td
                      key={`${row.rowKey}-${headerItem}`}
                      rowSpan={rowSpan}
                      style={{
                        color: fontColor,
                        backgroundColor: bgColor,
                        textAlign:
                          typeof formattedValue === "number"
                            ? valueAlignment
                            : rowAlignment,
                      }}
                      className={`w-auto border border-gray-300 text-[14px] font-normal truncate p-[0.5px] 
                      text-left pl-[1px] cursor-pointer ${
                        index === startScrolling - 1 ? "z-20" : ""
                      }`}
                    >
                      {typeof displayValue === "number"
                        ? renderFormattedNumber(
                            displayValue,
                            numberObject,
                            quickTable
                          )
                        : displayValue}
                    </td>
                  );
                } else {
                  // Skip rendering this cell if it's part of a merged group
                  return null;
                }
              })}
            </tr>
          );
        })}
      </tbody>
    );
  };

  const getColumnHeaderRowIndex = () => {
    const depthOfHeaders = groupByKeys.length + 1;
    const apArray = Array.from({ length: depthOfHeaders }, (_, index) => index);

    if (isMeasureOnTop && apArray.length > 0) {
      apArray.splice(0, 1); // Remove the first item if isMeasureOnTop is true
    } else if (apArray.length > 0) {
      apArray.splice(apArray.length - 1, 1); // Remove the last item otherwise
    }

    // console.log(depthOfHeaders, apArray);

    return apArray;
  };

  const rowsAvailableForColumnHierarchy = getColumnHeaderRowIndex();

  return (
    <div className={`overflow-auto max-h-full border border-gray-300 w-full`}>
      <table className="w-full border-collapse border border-gray-300 text-gray-700">
        <TableHeader
          tableHeader={tableHeader}
          sortArray={sortArray}
          rowKeys={rowKeys}
          hierarchy={hierarchy}
          Sheetid={Sheetid}
          isColumnPresent={isColumnPresent}
          valueKeys={valueKeys}
          groupByKeys={groupByKeys}
          rowsAvailableForColumnHierarchy={rowsAvailableForColumnHierarchy}
          isMeasureOnTop={isMeasureOnTop}
          vizType={vizType}
        />
        {renderTableRows()}
      </table>
    </div>
  );
}
